module.exports = __webpack_public_path__ + "static/media/crop-alt.8eab26c7.svg";